import Usuario from '../entities/DadosUsuario'
import { IUserRepository } from '../repositories/IUserRepository'

export interface IListUsuario {
  execute(nome: string): Promise<Usuario[]>
}

export class ListUsuario implements IListUsuario {
  constructor(private readonly userRepository: IUserRepository) {}
  public async execute(nome: string): Promise<Usuario[]> {
    return this.userRepository.findAllUsuario(nome)
  }
}
